/* Warenkorb-Empfehlungen (parfumtesten): Custom Element wird immer
   registriert, auch wenn der Warenkorb beim Seitenaufruf leer war –
   per innerHTML nachgeladene <script>-Tags werden nie ausgeführt. */
if (!customElements.get('duft-upsell')) {
  window.DftUpsellCache = window.DftUpsellCache || {};
  customElements.define('duft-upsell', class extends HTMLElement {
    connectedCallback() {
      // Nach dem Rendern des Drawers in Ruhe nachladen
      requestAnimationFrame(() => this.laden());
      const band = this.querySelector('[data-dft-upsell-band]');
      const zurueck = this.querySelector('[data-dft-upsell-prev]');
      const weiter = this.querySelector('[data-dft-upsell-next]');
      if (band && zurueck) zurueck.addEventListener('click', () => band.scrollBy({ left: -band.clientWidth, behavior: 'smooth' }));
      if (band && weiter) weiter.addEventListener('click', () => band.scrollBy({ left: band.clientWidth, behavior: 'smooth' }));
    }
    imKorb() {
      return (this.dataset.imKorb || '').split(',').filter(Boolean);
    }
    laden() {
      const seed = this.dataset.seed;
      const schluessel = seed + '|' + this.dataset.imKorb;
      if (window.DftUpsellCache[schluessel]) return this.zeigen(window.DftUpsellCache[schluessel]);
      const empfohlen = seed
        ? fetch('/recommendations/products.json?product_id=' + seed + '&limit=10&intent=related').then((r) => r.ok ? r.json() : { products: [] })
        : Promise.resolve({ products: [] });
      empfohlen
        .then((d) => {
          const treffer = this.filtern(d.products || []);
          if (treffer.length >= 2 || !this.dataset.fallback) return treffer;
          // Zu wenig passende Empfehlungen: Fallback-Kollektion dazuladen
          return fetch('/collections/' + this.dataset.fallback + '/products.json?limit=14')
            .then((r) => r.ok ? r.json() : { products: [] })
            .then((f) => {
              const extra = this.filtern(f.products || []).filter((p) => !treffer.some((t) => t.id === p.id));
              return treffer.concat(extra);
            });
        })
        .then((liste) => {
          window.DftUpsellCache[schluessel] = liste;
          this.zeigen(liste);
        })
        .catch(() => {});
    }
    filtern(produkte) {
      const drin = this.imKorb();
      return produkte.filter((p) => p.available !== false && !drin.includes(String(p.id))).slice(0, 10);
    }
    geld(cent) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
    }
    zeigen(liste) {
      if (!liste.length) return;
      const band = this.querySelector('[data-dft-upsell-band]');
      if (!band) return;
      band.replaceChildren();
      liste.forEach((p) => {
        const varianten = (p.variants || []).filter((v) => v.available !== false);
        if (!varianten.length) return;
        const karte = document.createElement('div');
        karte.className = 'dft-upsell__karte';
        const bildUrl = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
        const bild = bildUrl ? '<a class="dft-upsell__bildlink" href="/products/' + p.handle + '" tabindex="-1"><img class="dft-upsell__bild" src="' + bildUrl + (bildUrl.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="80" height="80"></a>' : '';
        let wahl;
        if (varianten.length > 1) {
          wahl = '<select class="dft-upsell__wahl" aria-label="Größe wählen">' + varianten.map((v) => '<option value="' + v.id + '">' + v.title + ' · ' + this.geld(v.price) + '</option>').join('') + '</select>';
        } else {
          wahl = '<span class="dft-upsell__preis">' + this.geld(varianten[0].price) + '</span><input type="hidden" class="dft-upsell__wahl" value="' + varianten[0].id + '">';
        }
        karte.innerHTML = bild
          + '<div class="dft-upsell__info">'
          + '<a class="dft-upsell__name" href="/products/' + p.handle + '"></a>'
          + '<div class="dft-upsell__wahlzeile">' + wahl
          + '<button type="button" class="dft-upsell__plus" data-dft-upsell-add aria-label="Hinzufügen">'
          + '<svg viewBox="0 0 14 14" fill="none" width="12" height="12" aria-hidden="true"><path d="M7 1.4v11.2M1.4 7h11.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
          + '</button></div></div>';
        karte.querySelector('.dft-upsell__name').textContent = p.title;
        karte.querySelector('[data-dft-upsell-add]').addEventListener('click', (e) => this.hinzufuegen(e.currentTarget));
        band.appendChild(karte);
      });
      if (band.children.length) this.hidden = false;
    }
    hinzufuegen(knopf) {
      const karte = knopf.closest('.dft-upsell__karte');
      const wahl = karte && karte.querySelector('.dft-upsell__wahl');
      if (!wahl || !wahl.value) return;
      knopf.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(wahl.value, 10), quantity: 1 }] })
      })
        .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
        .then(() => fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble'))
        .then((r) => r.json())
        .then((teile) => {
          const halter = document.createElement('div');
          halter.innerHTML = teile['cart-drawer'] || '';
          const neuesInnen = halter.querySelector('.drawer__inner');
          const altesInnen = document.querySelector('cart-drawer .drawer__inner');
          if (neuesInnen && altesInnen) altesInnen.innerHTML = neuesInnen.innerHTML;
          const blase = document.getElementById('cart-icon-bubble');
          if (blase && teile['cart-icon-bubble']) {
            const nb = document.createElement('div');
            nb.innerHTML = teile['cart-icon-bubble'];
            blase.innerHTML = nb.innerHTML;
          }
        })
        .catch(() => { knopf.disabled = false; });
    }
  });
}
